import styled from 'styled-components'

interface IProps {
  checked?: boolean
  disabled?: boolean
}

export const Container = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  * {
    cursor: pointer;
  }
`
const Label = styled.span<IProps>`
  margin-left: 5px;
  font: normal normal bold 14px/17px Inter;
`

export const NormalLabel = styled(Label)`
  color: ${({ checked, theme }) => (checked ? theme.colors.color378ff7 : theme.colors.color6b7786)};
`

export const AlertLabel = styled(Label)`
  color: ${props => props.theme.colors.colorcd1f1f};
`
